export enum TabType {
  BASIC = 'basic',
  APPOINTEES = 'appointees',
  CONTACTS = 'contacts',
  DETAIL = 'detail',
  REPORTING = 'reporting',
  CONSTITUTION = 'constitution',
  INTERACTIONS = 'interactions',
  WIDGETS = 'widgets'
}
